export default __webpack_public_path__ + "static/media/YAS0720.34I-34464_-18899_0.fb00c709.jpg";